import * as React                   from 'react'
// @ts-ignore
import classnames                   from 'classnames'
import { Props, SIZE, SIZE_CLASS }   from './types'
import './styles.scss'

export class Kpi extends React.Component<Props>{
  constructor(props: Props) {
      super(props)

      this.isBase64 = this.isBase64.bind(this)
      this.setElementSize = this.setElementSize.bind(this)
  }

  isBase64(str: string) {
    try {
        return btoa(atob(str)) === str;
    } catch (err) {
        return false;
    }
  }

  setElementSize(size: string){
    if (size === SIZE.LARGE) return SIZE_CLASS.LARGE
    if (size === SIZE.MEDIUM) return SIZE_CLASS.MEDIUM
    if (size == SIZE.SMALL) return SIZE_CLASS.SMALL
    return SIZE_CLASS.CUSTOM
  }

  render() {
    const {
      title,
      icon,
      value,
      size,
      customClass,
      style,
    } = this.props

    if (!title && !size) return null;
    if (typeof title !== 'string' || typeof size !== 'string') return null;

    if (size in SIZE) {
      return (
        <div
          className={classnames("topIconWrapper", `topIconWrapper-${size}`, customClass,  this.setElementSize(size))}
          style={style}
        >
            <div className={classnames("topIcon", `topIcon-${size}`)}>
              <div className="topIcon__text">
                {
                  title ?
                  (
                    <p className={classnames('topIcon__title', `topIcon__title-${size}`)}>{ title }</p>
                  ) : null
                }
                <p className={classnames('topIcon__count', `topIcon__count-${size}`)}>{ value ? value : 0 }</p>
              </div>
              <div className="topIcon__icon">
                {
                  icon && this.isBase64(icon) ?
                  (
                    <img className="topIcon__svg" src={icon}/>
                  ) : null
                }
              </div>
          </div>
        </div>
      )
    }

    return null
  }
}
